export default __webpack_public_path__ + "static/media/structure.e29d2e3d.svg";